module.exports = __webpack_public_path__ + "img/addition.09375a50.svg";